import { DocumentType, Language, Platform } from "@biblioteksentralen/cordata";
import { LanguagesSignature } from "./languages";
import { ExternalContentService } from "./externalContentService";
import { LCWorkTriple } from "./LCWorkTriple";
import { sift } from "radash";

export type VariantSignatures = {
  languagesSignature?: LanguagesSignature;
  documentTypeSignature?: string;
  externalContentServiceOriginSignature?: string;
  totalSignature: string;
};

export type VariantWithTriples = {
  variant: LCVariant;
  workTriples: LCWorkTriple[];
};

export class LCVariant {
  public languages: Language[] | undefined;
  public documentType: DocumentType | undefined;
  public externalContentService: ExternalContentService | undefined;
  public platforms: Platform[] | undefined;
  public signatures: VariantSignatures;

  constructor(workTriple: LCWorkTriple) {
    this.languages = workTriple.languages;
    this.documentType = workTriple.documentType;
    this.externalContentService = workTriple.externalContentService;
    this.platforms = workTriple.platforms;

    const languagesSignature = workTriple.languagesSignature;
    const documentTypeSignature = workTriple.documentTypeLabel;
    const externalContentServiceOriginSignature = workTriple.externalContentService?.originName;

    this.signatures = {
      languagesSignature,
      documentTypeSignature,
      externalContentServiceOriginSignature,
      totalSignature: sift([languagesSignature, documentTypeSignature, externalContentServiceOriginSignature]).join(
        "-"
      ),
    };
  }
}
